export default __webpack_public_path__ + "static/media/sounds/ran_numbers_practice_ready_instruction_alyx.mp3";